import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import { AuctionApplication, ChatButton } from '@adc/ui-adc'
import { standardSchemas } from '@adc/analytics'
import configment from '@adc/configment'
import analytics from '../services/analytics'
import types from '../constants/propTypes'
import STATICS from '../statics'
import { initUser } from '../actions/user'
import auctionSmartAppImg from '../assets/auction_smart_banner_logo.svg'
import CalendarPanel from './calendarPanel'

import '@adc/ui-adc/lib/styles.css'

class AuctionApp extends Component {
  static propTypes = {
    featureFlags: types.featureFlags.isRequired,
    user: types.user.isRequired,
    params: types.params,
    onAuthenticationComplete: PropTypes.func.isRequired,
    ssrHints: PropTypes.object,
  }

  componentDidMount() {
    const { params, user } = this.props
    const productType =
      params && params.product_type
        ? STATICS.AUCTION_TYPE_LIST.find(
            entry => entry.value === params.product_type
          )
        : null
    const pageName = `calendar|${productType ? productType.value : 'all'}`
    const lob = productType ? productType.lob : 'all'
    analytics.trackPageLoad(user, {
      pageName,
      lob,
      testId1: '10010',
      testVariant1: this.props.featureFlags['fe.resi.enable-new-navigation']
        ? 'new_nav_feb26'
        : 'control_nav',
    })
  }

  render() {
    const { featureFlags, user, params, onAuthenticationComplete, ssrHints } =
      this.props

    const ADC_LOGO = configment.get('AUCTIONCOM_LOGO_URL', '')
    const ADC_CALENDAR_BREADCRUMB = {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@id': `https://www.auction.com`,
            name: 'Auction.com',
          },
        },
      ],
    }
    const headerDataStructure = [
      standardSchemas.corporateSchema(ADC_LOGO),
      standardSchemas.searchSiteSchema(),
      standardSchemas.organizationSchema(ADC_LOGO),
      standardSchemas.webPageSchema(
        'https://www.auction.com/calendar',
        STATICS.PAGE_TITLE,
        STATICS.PAGE_DESCRIPTION,
        ADC_CALENDAR_BREADCRUMB,
        [
          'real estate auction calendar',
          'auction calendar',
          'foreclosure auction calendar',
          'REO Bank Owned auction calendar',
        ]
      ),
    ]

    const helmetConfig = {
      title: STATICS.PAGE_TITLE,
      description: STATICS.PAGE_DESCRIPTION,
      children: (
        <script type='application/ld+json'>
          {JSON.stringify(headerDataStructure)}
        </script>
      ),
    }
    const isNewNavigationEnabled = featureFlags['fe.resi.enable-new-navigation']

    const headerProps = {
      user: user.logged_in ? user : null,
      redirectOnSelected: true,
      showLiveChat: true,
      featureFlags,
      ...(isNewNavigationEnabled && {
        enableNewMobileHeader: true,
        newMobileHeaderLogoVariant: 'icon',
      }),
    }

    const footerProps = {
      useDeprecatedPageWidth: true,
    }

    const capabilities = {
      authentication: {
        enabled: true,
        options: {
          onAuthenticationComplete,
        },
      },
    }

    return (
      <AuctionApplication
        sspConfig={configment.get()}
        featureFlags={featureFlags}
        user={user}
        helmetConfig={helmetConfig}
        headerProps={headerProps}
        footerProps={footerProps}
        capabilities={capabilities}
        ssrHints={ssrHints}
      >
        <Helmet
          link={[
            { rel: 'android-touch-icon', href: auctionSmartAppImg },
            { rel: 'apple-touch-icon', href: auctionSmartAppImg },
          ]}
        />

        <CalendarPanel params={params} />
        <ChatButton />
      </AuctionApplication>
    )
  }
}

const mapStateToProps = store => ({
  featureFlags: store.featureFlags,
  user: store.user,
})

const mapDispatchToProps = dispatch => ({
  onAuthenticationComplete: ({ user }) => dispatch(initUser(user)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AuctionApp)
